import React, { useState } from 'react';

import Title from '../../Components/Admin/Title';

import { FaUniversity } from "react-icons/fa";

import useFetchApi from '../../hooks/useFetchApi';

import usePagination from '../../hooks/usePagination';
import { ACCOUNT_INFO_FETCH_URL, ACCOUNT_INFO_PAYMENT_RETURN_URL } from '../../utils/Constant';
import { authHeaders } from '../../utils/api';

function BookingAccountInfo() {

    const [remark, setRemark] = useState('');

    //const url = 'http://localhost:8000/api/admin/account-info';

    // const { data } = useFetchApi({
    //     url,
    //     dataKey: 'accounts'
    // });

    // const { data } = useFetchApi({
    //     url: 'http://localhost:8000/api/admin/account-info',
    //     dataKey: 'accounts',
    //     token: localStorage.getItem("admin_token"), // ✅ auth token
    // });

    const { data } = useFetchApi({
        url: ACCOUNT_INFO_FETCH_URL,
        dataKey: 'accounts',
        authType: 'admin'
    });

    console.log('accounts', data);




    const {
        currentItems,
        getVisiblePages,
        currentPage,
        setCurrentPage,
        handlePrev,
        handleNext,
    } = usePagination({
        data,
        itemShowPerPage: 5
    });

    const showRemark = (id) => {
        const newReamrk = data.find((item) => item.id === id)
        // setAddress()
        console.log('newReamrk', newReamrk);

        setRemark(newReamrk.remark);

        document.getElementById('my_modal_3').showModal();
    }

    const handlePaymentReturn = async (id) => {
        try {
            const res = await fetch(
                ACCOUNT_INFO_PAYMENT_RETURN_URL,
                {
                    method: "POST",
                    headers: authHeaders(),
                    body: JSON.stringify({
                        id,
                        payment_return_status: 2,
                    }),
                }
            );

            const result = await res.json();

            if (result.success) {
                alert("Payment marked as returned");
                window.location.reload();
            }
        } catch (error) {
            console.log(error);
        }
    };
    return (
        <>
            <Title
                icon={FaUniversity}
                title='Booking Account Info'
            />

            <div className="bg-white rounded shadow-lg mt-5">

                <h4 className="text-lg p-4 font-semibold border-b">
                    Booking Account Information
                </h4>

                <div className="p-4">

                    <table className="border w-full">

                        <thead className='bg-gray-400 border'>

                            <tr>
                                <th className="border p-2">Sl No.</th>
                                <th className="border p-2">Name</th>
                                <th className="border p-2">Mandap</th>
                                <th className="border p-2">Reference No</th>
                                <th className="border p-2">Remark</th>
                                <th className="border p-2">Bank Name</th>
                                <th className="border p-2">Branch</th>
                                <th className="border p-2">IFSC</th>
                                <th className="border p-2">Account No</th>
                                <th className="border p-2">Status</th>
                                <th className="border p-2">Payment Status</th>
                                <th className="border p-2">Action</th>
                            </tr>

                        </thead>

                        <tbody>

                            {currentItems.map((item, index) => (

                                <tr key={item.id}>

                                    <td className="border p-2">
                                        {index + 1}
                                    </td>
                                    <td className="border p-2">
                                        {item.booking?.name}
                                    </td>

                                    <td className="border p-2">
                                        {item.booking?.mandap?.name}
                                    </td>
                                    <td className="border p-2">
                                        {item.booking?.booking_ref}
                                    </td>

                                    <td className="border p-2">

                                        <button className="badge badge-sm badge-outline" onClick={() => showRemark(item.id)}>Show Remark</button>
                                    </td>

                                    <td className="border p-2">
                                        {item.bank_name}
                                    </td>

                                    <td className="border p-2">
                                        {item.branch_name}
                                    </td>

                                    <td className="border p-2">
                                        {item.ifsc_code}
                                    </td>

                                    <td className="border p-2">
                                        {item.account_number}
                                    </td>

                                    <td className="border p-2">

                                        <span className={`badge badge-${item.status_badge} badge-outline`}>
                                            {item.status_label}
                                        </span>

                                    </td>

                                    <td className="border p-2">
                                        <span className={`badge badge-${item.payment_return_badge} badge-outline`}>
                                            {item.payment_return_label}
                                        </span>
                                    </td>
                                    <td className="border p-2 text-center">
                                        {item.payment_return_status === 1 ? (
                                            <button
                                                onClick={() => handlePaymentReturn(item.id)}
                                                className="btn btn-error btn-sm text-white"
                                            >
                                                Mark Returned
                                            </button>
                                        ) : (
                                            <span className="text-green-600 font-semibold">
                                                Completed
                                            </span>
                                        )}
                                    </td>

                                </tr>

                            ))}

                        </tbody>

                    </table>

                    <div className="paginationContiner flex justify-between items-center my-4">

                        <button
                            className='btn btn-outline'
                            onClick={handlePrev}
                        >
                            Prev
                        </button>

                        <div className="join">

                            {getVisiblePages().map((page) => (

                                <button
                                    key={page}
                                    onClick={() => setCurrentPage(page)}
                                    className={`join-item btn btn-sm ${currentPage === page
                                        ? "btn-primary text-white"
                                        : "btn-outline"
                                        }`}
                                >
                                    {page + 1}
                                </button>

                            ))}

                        </div>

                        <button
                            className='btn btn-outline'
                            onClick={handleNext}
                        >
                            Next
                        </button>

                    </div>

                </div>

            </div>

            {/* Remarks modal */}
            <dialog id="my_modal_3" className="modal">
                <div className="modal-box">
                    <form method="dialog">
                        {/* if there is a button in form, it will close the modal */}
                        <button className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2">✕</button>
                    </form>
                    <h3 className="font-bold text-lg">Address!</h3>
                    <p className="py-4">{remark}</p>
                </div>
            </dialog>
        </>
    );
}

export default BookingAccountInfo;